<template>
  <b-navbar data-test-id="NavBarComponent" toggleable="lg" type="dark" class="nav-bar">
    <b-navbar-nav class="text-left">
      <slot name="left"></slot>
    </b-navbar-nav>

    <b-navbar-nav class="text-center justify-content-center">
      <slot name="center"></slot>
    </b-navbar-nav>

    <b-navbar-nav class="flex-row align-items-center text-right">
      <span class="flex"></span>
      <span
        v-if="liveConsult && liveConsult.started"
        class="live-consult-started mr-2"
        @click="maximizeLiveConsult"
      ></span>
      <span class="net-status mr-2">{{ netStatus }} </span>
      <slot name="right"></slot>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LoggerService as lgg } from "vue-components-library";

const LOG_TAG = "[CONNECTION]";

export default {
  name: "NavBar",
  data() {
    return {
      netStatus: "",
      connection: null,
    };
  },
  computed: {
    ...mapGetters("Case", { liveConsult: "liveConsult" }),
  },
  mounted() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      this.setNetworkStatus();
      this.connection = connection;
      connection.addEventListener("change", this.updateConnectionStatus);
    }
  },
  destroyed() {
    if (this.connection) {
      this.connection.removeEventListener("change", this.updateConnectionStatus);
    }
  },
  methods: {
    ...mapActions("PubNubSubscription", ["loadBroadcastHistory"]),
    ...mapActions("Case", ["liveConsultEvent"]),
    updateConnectionStatus() {
      this.setNetworkStatus();
      if (navigator.onLine) {
        this.loadBroadcastHistory();
      }
      lgg.info(
        `${LOG_TAG} Changed to ${this.netStatus} ${
          this.netStatus === "Online" ? this.connection.effectiveType : ""
        } at ${new Date().toISOString()}`,
      );
    },
    setNetworkStatus() {
      this.netStatus = navigator.onLine ? "Online" : "Offline";
    },
    maximizeLiveConsult() {
      this.liveConsultEvent({
        data: {
          liveConsult: {
            started: true,
            minimized: false,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
::v-deep .nav-link {
  padding: 0 !important;
}
.navbar-nav {
  flex: 1;
}
.navbar-nav:nth-child(2) {
  flex: 2;
}
.flex {
  flex: 3;
}
.live-consult-started {
  background-color: #28a745;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
}
.net-status {
  font-size: 0.7em;
}
@media screen and (max-width: 360px) {
  .text-left {
    font-size: small;
  }
}
</style>
